"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = useTraceUpdate;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = require("react");

function useTraceUpdate(props) {
  var prev = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    if (prev.current != null) {
      // don't output during initial render
      var changedProps = Object.entries(props).reduce(function (ps, _ref) {
        var _ref2 = (0, _slicedToArray2["default"])(_ref, 2),
            k = _ref2[0],
            v = _ref2[1];

        if (prev.current[k] !== v) {
          ps[k] = [prev.current[k], v];
        }

        return ps;
      }, {});

      if (Object.keys(changedProps).length > 0) {
        console.log('Changed props:', changedProps);
      } else {
        console.log('nothing changed');
      }
    }

    prev.current = props;
  });
}

if (process.env.NODE_ENV !== 'production') {
  global.useTraceUpdate = useTraceUpdate;
}
//# sourceMappingURL=useTraceUpdate.js.map